export default __webpack_public_path__ + "static/media/down_under.f0e4b8f6.png";